import defprotocol from '../defprotocol'
import Function from '../types/Function'

const Inheriter = defprotocol({
  inherit: Function
})

export default Inheriter
